import tw, { styled } from 'twin.macro';
import Button from '@/components/Forms/components/FormButton/FormButton';
import { StyledLink } from '../Link/Link.styles';

export const StyledCampaignForm = styled.div<{ hasDropShadow?: boolean }>`
  ${tw`p-4`}
  ${tw`bg-ui-colours-ui1`}
  ${({ hasDropShadow }) => hasDropShadow && tw`shadow-large border-4 border-primary-p1`}
  ${tw`rounded-xl`}
`;

export const StyledFormHeadline = styled.h2`
  ${tw`font-poppins font-semi-bold md:font-bold`}
  ${tw`text-body-xl md:text-heading-m text-secondary-s1 text-center `}
  ${tw`pb-5 md:pb-2`}
`;

export const StyledFormFooter = styled.div`
  ${tw`pt-2`}
  ${tw`text-center`}
  ${tw`flex flex-col items-center gap-3`}
`;

export const StyledButton = styled(Button)`
  ${tw`whitespace-normal`}
`;

export const StyledForm = styled.form`
  ${tw`flex flex-col gap-2`}
`;

export const StyledPdfPanel = styled.div`
  ${tw`p-4`}
  ${tw`flex justify-center items-center`}
`;

export const StyledAnchor = styled(StyledLink.withComponent('a'))``;
